import { mapState } from 'pinia';
import stores from 'store/modules';

export default {
    props: {
        position: { type: String, default: 'bottom-left' },
        disabled: { type: Boolean, default: false },
        tooltip: { type: String, default: '' },
        tooltipClass: { type: String, default: '' },
        closeOnClick: { type: Boolean, default: true },
        show: { type: Boolean, default: false },
        actions: { type: Boolean, default: true },
        keepOpenAfterSelect: { type: Boolean, default: false },
        containerClass: { type: String, default: '' },
    },

    data: () => ({
        active: false,
        blockOpen: false,
    }),

    emits: ['shown', 'hidden', 'icon-click-after'],

    computed: {
        classes() {
            let classes = {};

            classes[`is-${this.position}`] = true;
            classes['is-active'] = this.active;
            classes['is-disabled'] = this.disabled;

            return classes;
        },

        tooltipContent() {
            return {
                content: this.tooltip,
                popperClass: this.tooltipClass,
                html: true,
            };
        },

        clickable() {
            return !this.disabled;
        },

        ...mapState(stores.Dropdown, ['dropdown']),
    },

    watch: {
        show(value) {
            this.$store.dispatch('dropdownOpen', this.$.uid);
        },

        'dropdown.active'(uid) {
            if (this.show) return;

            this.active = uid === this.$.uid;
        },

        active(active) {
            if (active) {
                this.$emit('shown');
            } else {
                this.$emit('hidden');
            }
        },
    },

    methods: {
        activate(e) {
            if (
                this.active ||
                !this.clickable ||
                this.onBeforeActivate(e) === false ||
                this.blockOpen
            ) {
                this.blockOpen = false;
                return;
            }

            this.$store.dispatch('dropdownOpen', this.$.uid);
            this.clearTooltip();

            if (this.closeOnClick) {
                this.attachClickListeners();
            }

            this.onAfterActivate(e);
        },

        attachClickListeners() {
            [...this.$el.getElementsByClassName('dropdown-item')].forEach((item) => {
                if (
                    item.getAttribute('data-clickable') ||
                    item.querySelectorAll('input[type=checkbox],input[type="text"]').length
                ) {
                    return;
                }

                item.removeEventListener('click', () => {
                    this.handleItemClick(item);
                });

                item.addEventListener('click', () => {
                    this.handleItemClick(item);
                });

                item.setAttribute('data-clickable', true);
            });
        },

        handleItemClick(item) {
            if (item.classList.contains('no-click')) {
                return;
            }
            if (this.keepOpenAfterSelect) {
                return;
            }

            if (item.classList.contains('close-on-click')) {
                this.blockOpen = true;
                this.$store.dispatch('dropdownClose');
            }

            if (this.dropdown.active) {
                this.blockOpen = true;
                this.$store.dispatch('dropdownClose');
            }
        },

        clearTooltip() {
            this.$el.dispatchEvent(new Event('mouseout'));
            this.$el.dispatchEvent(new Event('mouseLeave'));
        },

        onBeforeActivate(e) {
            //
        },

        onAfterActivate(e) {
            this.$emit('icon-click-after', e);
        },
    },

    beforeRouteLeave(to, from, next) {
        this.$store.dispatch('dropdownClose');
        next();
    },

    mounted() {
        this.$el.onclick = function (e) {
            e.stopPropagation();
        };

        if (this.closeOnClick) {
            this.attachClickListeners();
        }

        // Attach a global click handler so if a dropdown is open when a
        // click happens, the dropdown will close.
        if (!this.dropdown.initialized) {
            this.$store.dispatch('dropdownInit');

            document.body.addEventListener('click', (e) => {
                if (this.dropdown.active && e.detail) {
                    this.$store.dispatch('dropdownClose');
                }
            });
        }
    },
};
